export const data = [
    {
      num: "/01",
      title: "IT staff augmentation",
      text: "We are glad to subcontract a part of your development works, to enhance your team with our specialists, to work in close technological integrity with your managers, developers and other specialists. We are ready to sign NDA and follow its requirements."
    },
    {
      num: "/02",
      title: "Non-typical projects",
      text: "Our specialty is complicated and non-typical projects with not completely clear initial requirements which can change in the implementation course. "
    },
    {
      num: "/03",
      title: "Time & material",
      text: "With our work model the customer pays only for actual time consumed by our specialists for the projects. Payment is made on monthly basis upon the works performed. "
    },
    {
      num: "/04",
      title: "Personal manager",
      text: "If necessary we provide a personal manager to collect and formalize the requirements as well as a designer to complete small tasks. "
    },
  ];
  